import { render } from "./ForceChangePassword.vue?vue&type=template&id=967600ca&scoped=true"
import script from "./ForceChangePassword.vue?vue&type=script&lang=js"
export * from "./ForceChangePassword.vue?vue&type=script&lang=js"

import "./ForceChangePassword.vue?vue&type=style&index=0&id=967600ca&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-967600ca"]])

export default __exports__